export function addBronsonClasses() {
  const xs2aForm = document.getElementById("XS2A-Form");

  if (xs2aForm) {
    const xs2aSelects = xs2aForm.getElementsByClassName("xs2a-select");
    addBronsonSelectClasses(xs2aSelects);

    const xs2aTexts = xs2aForm.getElementsByClassName("xs2a-text");
    addBronsonInputTextClasses(xs2aTexts);

    const xs2aCheckboxes = xs2aForm.getElementsByClassName("xs2a-checkbox");
    addBronsonCheckboxClasses(xs2aCheckboxes);

    const buttonContainer = xs2aForm.getElementsByClassName("xs2a-submit-line");
    if (buttonContainer.length) {
      buttonContainer[0].classList.add("o-button-container");
    }

    const submitButtons = xs2aForm.getElementsByClassName("xs2a-submit");
    addBronsonButtonClasses(submitButtons);
    const backButtons = xs2aForm.getElementsByClassName("xs2a-back");
    addBronsonButtonClasses(backButtons);
  }
}

function addBronsonInputTextClasses(collection: HTMLCollectionOf<Element>) {
  for (const textDiv of collection) {
    textDiv.querySelector("input")?.classList.add("c-input__input");
  }
}

function addBronsonSelectClasses(collection: HTMLCollectionOf<Element>) {
  for (const selectDiv of collection) {
    const select = selectDiv.querySelector("select");
    select?.classList.add("c-input__input");
    select && wrapElement(select, "div", ["c-input", "c-input--select"]);
  }
}

function addBronsonButtonClasses(collection: HTMLCollectionOf<Element>) {
  for (const button of collection) {
    button.classList.add("c-btn");
    button.classList.add("o-button-container__button");
  }
}

function addBronsonCheckboxClasses(collection: HTMLCollectionOf<Element>) {
  for (const inputDiv of collection) {
    const input = inputDiv.querySelector("input");
    const label = inputDiv.querySelector("label");
    input?.classList.add("c-checkbox__input");
    label?.classList.add("c-checkbox__label");
  }
}

function wrapElement(
  element: HTMLElement,
  wrapperType: string,
  classNames: string[]
) {
  const wrapper = document.createElement(wrapperType);
  classNames.forEach((className) => {
    wrapper.classList.add(className);
  });
  wrapper.appendChild(element.cloneNode(true));
  element.parentNode?.replaceChild(wrapper, element);
  return wrapper;
}
